/**
 * 前端时区处理工具函数
 * 统一处理UTC时间戳与温哥华时区显示之间的转换
 */

// 温哥华时区标识
const VANCOUVER_TIMEZONE = 'America/Vancouver';

/**
 * 将UTC时间戳转换为温哥华本地时间显示
 * @param utcTimestamp UTC时间戳字符串
 * @returns 格式化的温哥华本地时间字符串 (HH:MM 格式)
 */
export function convertUTCToVancouverTime(utcTimestamp: string): string {
  return new Date(utcTimestamp).toLocaleTimeString('en-US', {
    timeZone: VANCOUVER_TIMEZONE,
    hour12: false,
    hour: '2-digit',
    minute: '2-digit'
  });
}

/**
 * 将UTC时间戳转换为温哥华本地日期显示
 * @param utcTimestamp UTC时间戳字符串
 * @returns 格式化的温哥华本地日期字符串
 */
export function convertUTCToVancouverDate(utcTimestamp: string): string {
  return new Date(utcTimestamp).toLocaleDateString('en-US', {
    timeZone: VANCOUVER_TIMEZONE,
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

/**
 * 将UTC时间戳转换为温哥华本地日期和时间显示
 * @param utcTimestamp UTC时间戳字符串
 * @returns 格式化的温哥华本地日期时间字符串
 */
export function convertUTCToVancouverDateTime(utcTimestamp: string): string {
  return new Date(utcTimestamp).toLocaleString('en-US', {
    timeZone: VANCOUVER_TIMEZONE,
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
}

/**
 * 格式化偏好日期显示（处理 YYYY-MM-DD 格式）
 * @param dateString 日期字符串 (YYYY-MM-DD)
 * @returns 格式化的温哥华本地日期字符串
 */
export function formatPreferredDate(dateString: string): string {
  // 处理 YYYY-MM-DD 格式的日期字符串，显示为温哥华时区
  const date = new Date(dateString + 'T00:00:00-07:00'); // 明确指定温哥华时区
  return date.toLocaleDateString('en-US', {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: VANCOUVER_TIMEZONE
  });
}

/**
 * 格式化普通日期显示
 * @param dateString UTC日期时间字符串
 * @returns 格式化的温哥华本地日期字符串
 */
export function formatDate(dateString: string): string {
  // 将UTC时间转换为温哥华时区显示
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: VANCOUVER_TIMEZONE
  });
}

/**
 * 格式化时间范围显示
 * @param startTimeUTC 开始时间UTC时间戳
 * @param endTimeUTC 结束时间UTC时间戳
 * @returns 格式化的温哥华时间范围字符串
 */
export function formatTimeRange(startTimeUTC: string, endTimeUTC: string): string {
  const startTime = convertUTCToVancouverTime(startTimeUTC);
  const endTime = convertUTCToVancouverTime(endTimeUTC);
  return `${startTime} - ${endTime} (Vancouver)`;
}